import React, { createContext, useContext, useMemo } from 'react';
import { DEFAULT_MARKDOWN_SIZE, getTextSizePreset } from './textSizePresets';

const MarkdownSizeContext = createContext(DEFAULT_MARKDOWN_SIZE);

export function MarkdownSizeProvider({ size = DEFAULT_MARKDOWN_SIZE, children }) {
    return (
        <MarkdownSizeContext.Provider value={size}>
            {children}
        </MarkdownSizeContext.Provider>
    );
}

export function useMarkdownSize() {
    return useContext(MarkdownSizeContext);
}

export function useMarkdownPreset() {
    const size = useMarkdownSize();
    return useMemo(() => getTextSizePreset(size), [size]);
}
